import type { FC } from 'react';

import { useGameConfigSlice } from '../../../store/slices/config/selectors';

import { HelpChapterCrashAutoCashingOut } from './HelpChapterCrashAutoCashingOut';

export const HelpChapterCrashAutoCashingOutConnected: FC = () => {
  const customMultiplierCap = useGameConfigSlice.getCustomMultiplierCap();

  return <HelpChapterCrashAutoCashingOut maxMultiplier={customMultiplierCap} />;
};
